//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_URL = "/prototype/global-reporting";
import { createExport } from "@/mixins/createExport";

export default {
  mixins: [createExport],
  data: function data() {
    return {
      as_of_date: moment().format("MM/DD/YYYY"),
      headers: ["Property", "Unit Type", "Bed/Bath", "SQ FT", { title: "ProForma", filter: "toCurrency" }, { title: "Lease", filter: "toCurrency" }, { title: "Classic Lease", filter: "toCurrency" }, { title: "Renovated Lease", filter: "toCurrency" }, { title: "ProForma / SqFt", filter: "toCurrency" }, { title: "Lease / SqFt", filter: "toCurrency" }, "Units", "On Notice", "Vac.", "Classic Vac.", "Reno Vac.", "Current Renovated", "Reno %", "Current Classic", "Occ.", { title: "Current Rate", filter: "toCurrency" }, { title: "Premium", filter: "toCurrency" }],
      fields: ["Property", "Unit Type", "Bed/Bath", "SQ FT", "Current Yr ProForma", "Lease", "Classic Lease", "Renovated Lease", "ProForma / Sq Ft", "Lease / Sq Ft", "Units", "On Notice", "Vac", "Classic Vac", "Reno Vac", "Current Reno", "Reno %", "Current Classic", "Occ", "Current Rate", "Premium"],
      items: [],
      loading: false
    };
  },
  created: function created() {
    var _this = this;

    Event.$on("exportPricePlanningToExcel", this.exportReport);
    Event.$on("price-planning-analysis", function () {
      _this.$children[0].showModal = true;
      _this.load();
    });
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off("exportPricePlanningToExcel");
    Event.$off("price-planning-analysis");
  },

  methods: {
    load: function load() {
      var _this2 = this;

      this.items = [];
      this.loading = true;
      axios.post(BASE_URL + "/price-planning-analysis").then(function (response) {
        _this2.items = response.data;
        _this2.loading = false;
      });
    },
    exportReport: function exportReport() {
      this.loading = true;

      var data = {
        exportExcel: true
      };

      this.createExport(data, BASE_URL + "/price-planning-analysis", "price-planning-analysis", ".xlsx");

      this.loading = false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reporting/PricePlanningAnalysisReport.vue
// module id = jFCI
// module chunks = 0 1